export const css = {
    root: '_2CvJOUac',
    nav_drawer: '_2fxazHi6',
    title: '_21Sqgahv',
    ' _key': 'apic-theme/apic/table-of-contents/drawer'
};
export default css;
